export default __webpack_public_path__ + "static/media/c7f930d10b1a4ac6ddca95f648938252.svg";